import API from "../../../api/axiosClient";
import { CreateGroupCreationRequestDto, GroupCreationRequestDto, RejectGroupCreationRequestDto } from "../types/GroupCreationRequest";

 
 

const controller = "GroupCreationRequest";

const GroupCreationRequestService = {

    create: async (
        dto: CreateGroupCreationRequestDto
    ): Promise<void> => {

        await API.post(
            controller,
            dto
        );

    },

    getAll: async ()
        : Promise<GroupCreationRequestDto[]> => {

        const response =
            await API.get(controller);

        return response.data;

    },

    getMyRequests: async ()
        : Promise<GroupCreationRequestDto[]> => {

        const response =
            await API.get(
                `${controller}/myrequests`
            );

        return response.data;

    },

    approve: async (
        requestId: string
    ): Promise<void> => {

        await API.put(
            `${controller}/${requestId}/approve`
        );

    },

    reject: async (
        requestId: string,
        dto: RejectGroupCreationRequestDto
    ): Promise<void> => {

        await API.put(
            `${controller}/${requestId}/reject`,
            dto
        );

    }

};

export default GroupCreationRequestService;